import { Plus } from "lucide-react";
import { useCallback } from "react";

import { useFileUpload } from "@/components/file-upload-context";
import { Button } from "@/components/ui/button";
import { FileType } from "@/lib/uploads";

export const AddTrackButton = () => {
  const {
    openFilePicker,
    isUploading,
    currentFileCount,
    totalFileCount,
    uploadProgress,
  } = useFileUpload();

  const handleAddTrack = useCallback(() => {
    openFilePicker(FileType.AUDIO);
  }, [openFilePicker]);

  return (
    <Button
      type="button"
      variant="secondary"
      className="w-full mb-0"
      onClick={handleAddTrack}
      disabled={isUploading}
    >
      {isUploading ? (
        <>
          {`${uploadProgress}% - Files ${currentFileCount} of ${totalFileCount}`}
        </>
      ) : (
        <>
          <Plus className="size-4" /> Add files
        </>
      )}
    </Button>
  );
};
